import React from 'react';
import { StyledButton, MoveMsg, MoveMsgText, MoveMsgBtn } from './MoveEventsPopup.styles';
import { IRotationNode } from '../../../types/ViewModel/IRotationNode';

type Props = {
    node: IRotationNode;
    onCancelMoveBtn: () => void;
    onMoveBtn: (node: IRotationNode) => void;
    onOkMoveBtn: () => void;
};

const MoveEventsPopupComponent: React.FC<Props> = (props) => {
    return (
        <MoveMsg>
            <MoveMsgText>{props.node.actionMsg.moveToNodeText}</MoveMsgText>
            {props.node.actionMsg.doAction && (
                <MoveMsgBtn>
                    <StyledButton className="cancel-btn" disabled={false} isSelected={true} onClick={() => props.onCancelMoveBtn()}>
                        Cancel
                    </StyledButton>
                    <StyledButton className="primary-btn" disabled={false} isSelected={true} onClick={() => props.onMoveBtn(props.node)}>
                        Move
                    </StyledButton>
                </MoveMsgBtn>
            )}
            {!props.node.actionMsg.doAction && (
                <MoveMsgBtn>
                    <StyledButton className="primary-btn" disabled={false} isSelected={true} onClick={() => props.onOkMoveBtn()}>
                        Ok
                    </StyledButton>
                </MoveMsgBtn>
            )}
        </MoveMsg>
    );
};

export default MoveEventsPopupComponent;
